module.exports = __webpack_public_path__ + "img/passionfruit-pineapple-xxl.d6aff1b9.png";